/* Kidnomics points — CART SURFACE for the live theme ("Kidnomics Perpetual Unlock
   with Points", Dawn-based). Ports the proven dev cart logic (theme/assets/
   kidnomics-points.js) with two production adaptations:
     1) AUTH: no demo parentId. Identity is the real parent's Supabase JWT, read
        from window.kidnomicsUser.accessToken (set by the theme.liquid auth bridge)
        and sent as `Authorization: Bearer` (a HEADER — never in the URL/logs; resolveAuth reads Bearer first).
        No token  -> do NOT intercept checkout, do NOT render a panel (logged-out /
        non-member carts behave exactly like stock checkout).
     2) SELECTORS: re-derived for THIS theme (Dawn), not Horizon. See SELECTOR notes.
   PRODUCT side is NOT here — the existing main-product.liquid kidnomics_slider block
   owns it (repointed to /embed/slider). This file is cart panel + checkout interception only.
   No discount-code UI anywhere (§6 Option A); points language only. */
(function () {
  var KID = window.KIDNOMICS || {};
  var APP = (KID.appBase || '').replace(/\/$/, '');   // https://slider.kidnomics.com
  if (!APP) { console.warn('[kidnomics] no appBase'); return; }

  // Real auth: the parent's JWT from the theme auth bridge. NO demo scaffold.
  function token() { try { return (window.kidnomicsUser && window.kidnomicsUser.accessToken) || null; } catch (e) { return null; } }
  function authed() { return !!token(); }
  function authHeaders(extra) { var h = extra || {}; var t = token(); if (t) h['Authorization'] = 'Bearer ' + t; return h; }

  var fmtPts = function (n) { return Number(n).toLocaleString('en-US'); };
  var fmtUsd = function (c) { return '$' + (c / 100).toFixed(2); };
  var _ctoken = null;
  function cartToken() {
    if (_ctoken) return Promise.resolve(_ctoken);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { _ctoken = c.token; return _ctoken; });
  }

  // ---- brand tokens (scoped to our injected UI) ----
  (function styles() {
    var link = document.createElement('link'); link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@600;700;800&display=swap';
    document.head.appendChild(link);
    var s = document.createElement('style');
    s.textContent = [
      '.kid-wrap{--cream:#FBF5E9;--mint:#4CAF6F;--mint-d:#3C9A5C;--forest:#1A2E1E;--muted:#6E7A6C;--line:rgba(26,46,30,.12);font-family:"DM Sans",system-ui,sans-serif;color:var(--forest)}',
      '.kid-head{font-family:"Playfair Display",Georgia,serif}',
      '.kid-panel{background:#fff;border:1px solid var(--line);border-radius:16px;padding:16px 18px;margin:12px 0}',
      '.kid-row{display:flex;justify-content:space-between;gap:10px;padding:7px 0;border-bottom:1px solid var(--line)}',
      '.kid-tot{display:flex;justify-content:space-between;padding:3px 0}',
      '.kid-cart-panel{max-height:min(40vh,280px);overflow-y:auto}',
      'cart-drawer-items{min-height:30vh}'
    ].join('');
    document.head.appendChild(s);
  })();

  // ===== SELECTORS — re-derived for the live (Dawn) theme =====
  // Checkout trigger: BOTH live surfaces use button[name="checkout"]
  //   drawer  #CartDrawer-Checkout (form=CartDrawer-Form),  cart page #checkout (form=cart).
  var CHECKOUT_SEL = 'button[name="checkout"]';
  // Express/accelerated buttons — never intercept (they don't settle points, §6 MVP).
  // Live wraps Shopify dynamic-checkout in .additional_checkout_buttons / .additional-checkout-buttons.
  var EXPRESS_SEL = '[data-shopify="payment-button"], .shopify-payment-button, .additional_checkout_buttons, .additional-checkout-buttons, .cart__dynamic-checkout-buttons, accelerated-checkout-component, shopify-accelerated-checkout';
  // Cart surfaces (Dawn), verified in the export — NO bare `form` (avoids attaching to an
  // unrelated form): drawer <cart-drawer>/<cart-drawer-items>/#CartDrawer, cart page
  // <cart-items>/#main-cart-items, plus the CTA wrappers .cart__ctas/.checkout__buttons.
  var SURFACE_SEL = 'cart-drawer, cart-drawer-items, cart-items, #CartDrawer, #main-cart-items, .cart__ctas, .checkout__buttons';
  // Mutation-relevance: only refetch when a CART region mutates (not predictive search /
  // header / scroll animations elsewhere) — bounds the body observer.
  var CART_CTX = SURFACE_SEL;
  var _settling = false, _mutatingSelf = false, _refreshTimer = null, _reapplying = false, _autoScaling = false;
  // NUDGE — cached un-pointed snapshot from the last successful refreshCart() load.
  // Safe defaults (0 / false) => no banner, and the checkout confirm NEVER fires. Only set to
  // positive values when we POSITIVELY know there are un-pointed cart lines AND a spendable
  // balance; any missing/malformed data leaves these at the safe defaults so checkout is never
  // blocked (better to miss a nudge than to break the money path).
  var _unpointedCount = 0, _hasBalance = false;

  function checkoutTrigger(node) {
    var t = (node && node.closest) ? node.closest(CHECKOUT_SEL) : null;
    if (!t || t.closest(EXPRESS_SEL)) return null;
    return t;
  }

  function cartQtyMap(cart) {
    var map = {};
    (cart.items || []).forEach(function (it) { var v = String(it.variant_id); map[v] = (map[v] || 0) + (it.quantity || 0); });
    return map;
  }

  // NUDGE — distinct cart variants with NO points applied, plus the member's spendable balance.
  // Pure read over data loadCart() already fetched (no extra request). Wrapped in try/catch and
  // defaulting to a no-nudge result so malformed/error summaries never produce a banner or a
  // checkout confirm. summary.lines = active allocations (variants that HAVE points);
  // summary.expiredLines = lapsed allocations (still "pointed" for nudge purposes — they have a
  // re-apply path, so we don't nag about them); summary.availablePoints = scoped remaining balance.
  function computeUnpointed(summary, cart) {
    try {
      var pointed = {};
      ((summary && summary.lines) || []).forEach(function (l) { pointed[String(l.variantId)] = true; });
      ((summary && summary.expiredLines) || []).forEach(function (l) { pointed[String(l.variantId)] = true; });
      var seen = {}, count = 0;
      ((cart && cart.items) || []).forEach(function (it) {
        var v = String(it.variant_id);
        if (pointed[v] || seen[v]) return;   // already has points (active or expired), or already counted this variant
        seen[v] = true; count++;
      });
      var avail = (summary && typeof summary.availablePoints === 'number') ? summary.availablePoints : 0;
      return { count: count, hasBalance: avail > 0, available: avail };
    } catch (e) {
      return { count: 0, hasBalance: false, available: 0 };   // fail safe: no nudge, never block checkout
    }
  }

  // Points summary SCOPED to the live cart (variant:qty snapshot excludes stale allocations).
  function loadCart() {
    return Promise.all([cartToken(), fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); })])
      .then(function (arr) {
        var tok = arr[0], cart = arr[1], map = cartQtyMap(cart);
        var cartParam = Object.keys(map).map(function (v) { return v + ':' + map[v]; }).join(',');
        var url = APP + '/api/cart-summary?cartSession=' + encodeURIComponent(tok) + '&cart=' + encodeURIComponent(cartParam);
        return fetch(url, { headers: authHeaders() }).then(function (r) {
          // 401 = stale/expired token: do NOT .json() the error body into the panel (that
          // rendered NaN). Signal logged-out so the caller shows the login prompt instead.
          if (r.status === 401) return { summary: { unauthorized: true }, cart: cart, map: map, token: tok };
          if (!r.ok) throw new Error('cart-summary ' + r.status);
          return r.json().then(function (summary) { return { summary: summary, cart: cart, map: map, token: tok }; });
        });
      });
  }

  // Money-integrity guard: a points cart must never reach checkout un-settled.
  function settleAndGo() {
    if (_settling) return;
    _settling = true;
    loadCart().then(function (res) {
      // STALE-TOKEN GUARD (money-loss fix): a 401 from cart-summary yields { summary:{unauthorized:true} }
      // — a summary with NO lines. Without this check, the empty-lines branch below would send a
      // logged-in-but-token-expired member (who HAS points applied) to full-price /checkout, silently
      // dropping their discount. Instead: stop, re-show the login prompt, and do NOT proceed. Their
      // allocations are intact server-side; re-login + retry settles them. Never silently drop points.
      if (res.summary && res.summary.unauthorized) {
        _settling = false;
        try { renderLoggedOut(); } catch (e) {}
        alert('Your session expired. Please log in again at kidnomics.com to apply your points, then try checkout.');
        return;
      }
      var lines = (res.summary && res.summary.lines) || [];
      if (!lines.length) { window.location.href = '/checkout'; return; } // nothing to settle -> normal checkout
      return fetch(APP + '/api/checkout/settle', { method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ cartSessionId: res.token, actualQuantities: res.map }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.success && d.permalink) { window.location.href = d.permalink; }           // discounted checkout
          else { _settling = false; alert('Could not apply your points: ' + ((d && d.error) || 'unknown') + '\nPlease try again.'); }
        });
    }).catch(function (err) {
      _settling = false; console.warn('[kidnomics] settle failed', err);
      alert('We couldn\u2019t apply your points just now. Please try again.');   // never silently drop points
    });
  }

  // Re-apply state (Deploy 1: DISPLAY ONLY — the button is a no-op stub; Deploy 2 wires the
  // actual re-allocation). Savings is "up to ~$X" because cart-summary uses the STORED
  // per-unit cap; the real re-apply re-fetches the live cap and may land lower.
  // Logged-out / stale-token prompt (option i: generic, no per-cart detection — detecting a
  // logged-out cart's expired points would need an unauthenticated cart-token lookup).
  function loggedOutHtml() {
    return '<div class="kid-panel">' +
        '<div class="kid-head" style="font-size:18px;margin-bottom:4px">Kidnomics points</div>' +
        '<div style="font-size:13px;color:var(--muted)"><a href="https://kidnomics.com/login" style="color:var(--mint-d);font-weight:700;text-decoration:underline">Log in</a> to see and re-apply your Kidnomics points.</div>' +
      '</div>';
  }

  // Expired-re-apply SECTION (mixed-cart safe). Renders inline whenever there are expired-but-
  // in-cart lines, so it coexists with active-pointed rows AND the un-pointed nudge — instead of
  // the old all-or-nothing early-return that only showed when there were ZERO active lines (which
  // hid the expired line in any mixed cart — the bug a real user hit). Lists each expired variant
  // with its "up to ~$X" potential and one shared "Re-apply my points" button (the existing
  // .kid-reapply handler re-applies ALL expiredLines at tap-time). expiredLines already excludes
  // active variants (server-side), so this never double-counts a line that's currently pointed.
  function expiredSection(summary, titleByVariant) {
    var xl = (summary && summary.expiredLines) || [];
    if (!xl.length) return '';
    var save = fmtUsd(summary.expiredTotalCents || 0);
    var rows = xl.map(function (l) {
      var t = titleByVariant[String(l.variantId)] || 'Item';
      var qty = l.quantity > 1 ? ' \u00d7' + l.quantity : '';
      return '<div class="kid-row"><span style="font-weight:600">' + t + qty + '</span>' +
        '<span style="color:var(--muted);font-weight:600">up to ~\u2212' + fmtUsd(l.discountCents) + '</span></div>';
    }).join('');
    return '<div style="background:#FBF1DD;border:1px solid #E4C98A;border-radius:12px;padding:12px;margin-bottom:12px">' +
        '<div style="font-weight:700;color:#7A5212;font-size:14px;margin-bottom:6px">Your points reservation expired</div>' +
        rows +
        '<div style="font-size:12px;color:#6B5A38;margin:8px 0 10px">Your items are still here. Re-apply to save up to ~' + save + '.</div>' +
        '<button type="button" class="kid-reapply" style="width:100%;padding:11px 14px;border:none;border-radius:12px;background:var(--mint-d);color:#fff;font-weight:700;font-size:15px;cursor:pointer">Re-apply my points</button>' +
      '</div>';
  }

  function panelHtml(summary, cart, info) {
    var titleByVariant = {};
    (cart.items || []).forEach(function (it) { titleByVariant[String(it.variant_id)] = it.product_title; });
    // Expired-but-in-cart: renders as an inline SECTION (see expiredSection) that coexists with
    // active rows + the nudge — no longer an all-or-nothing early return.
    var expired = expiredSection(summary, titleByVariant);
    // UNDER-APPLIED SECTION (Bug 2b): when a member INCREASED an item's quantity in the cart after
    // applying points, the per-unit cap means more points COULD apply — but we never auto-spend
    // their balance (no-silent-spend invariant). cart-summary flags these lines underApplied:true
    // with additionalPoints. Show a consent-gated "apply N more points?" row; the button reuses the
    // hardened allocate path (POST /api/allocate at the line's CURRENT quantity → server caps to
    // cap×qty under a profile lock, re-validated, clamp-on-reject). Keyed strictly on underApplied
    // (NOT additionalPoints>0) so deliberately-partial applies never nag.
    var underLines = ((summary.lines) || []).filter(function (l) { return l.underApplied && !l.appliedAtMax && l.additionalPoints > 0; });
    var underSection = '';
    if (underLines.length) {
      var addTotal = 0;
      var uRows = underLines.map(function (l) {
        addTotal += l.additionalPoints;
        var t = titleByVariant[String(l.variantId)] || 'Item';
        var qty = l.quantity > 1 ? ' \u00d7' + l.quantity : '';
        return '<div class="kid-row"><span style="font-weight:600">' + t + qty + '</span>' +
          '<span style="color:var(--muted);font-weight:600">+' + fmtPts(l.additionalPoints) + ' pts avail.</span></div>';
      }).join('');
      underSection = '<div style="background:#FBF1DD;border:1px solid #E4C98A;border-radius:12px;padding:12px;margin-bottom:12px">' +
          '<div style="font-weight:700;color:#7A5212;font-size:14px;margin-bottom:6px">Quantity increased</div>' +
          uRows +
          '<div style="font-size:12px;color:#6B5A38;margin:8px 0 10px">You added more of these \u2014 apply up to ' + fmtPts(addTotal) + ' more points to cover the added quantity?</div>' +
          '<button type="button" class="kid-applymore" style="width:100%;padding:11px 14px;border:none;border-radius:12px;background:var(--mint-d);color:#fff;font-weight:700;font-size:15px;cursor:pointer">Apply ' + fmtPts(addTotal) + ' more points</button>' +
        '</div>';
    }
    var rows = ((summary.lines) || []).map(function (l) {
      var t = titleByVariant[String(l.variantId)] || 'Item';
      var qty = l.quantity > 1 ? ' \u00d7' + l.quantity : '';
      return '<div class="kid-row"><span style="font-weight:600">' + t + qty + '</span>' +
        '<span style="color:var(--mint-d);font-weight:700">\u2212' + fmtPts(l.points) + ' pts / \u2212' + fmtUsd(l.discountCents) + '</span></div>';
    }).join('');
    // NUDGE (Option B copy) — non-blocking banner at the TOP of the panel, shown ONLY when there
    // are un-pointed items AND a spendable balance. Warm amber-cream tint (brand-consistent,
    // reads as a notice). Teaches the CORRECT order (apply on the product page) rather than
    // instructing "remove + re-add" which would create duplicates. Uses "Apply Points".
    var banner = '';
    if (info && info.count > 0 && info.hasBalance) {
      var itemWord = info.count === 1 ? 'item' : 'items';
      var hasVerb = info.count === 1 ? "doesn\u2019t" : "don\u2019t";
      banner = '<div style="background:#FBF1DD;border:1px solid #E4C98A;border-radius:12px;padding:10px 12px;margin-bottom:12px">' +
          '<div style="font-weight:700;color:#7A5212;font-size:14px;margin-bottom:2px">You have ' + fmtPts(info.available) + ' points available</div>' +
          '<div style="font-size:13px;color:#6B5A38;line-height:1.4">' + info.count + ' ' + itemWord + ' in your cart ' + hasVerb + ' have points applied. To use your points, apply them on the product page before checking out.</div>' +
        '</div>';
    }
    return '<div class="kid-panel">' +
        banner +
        expired +
        underSection +
        '<div class="kid-head" style="font-size:18px;margin-bottom:4px">Your Kidnomics points</div>' +
        '<div style="font-size:12px;color:var(--muted);margin-bottom:10px">Applied per item — settled into one points redemption at checkout.</div>' +
        (rows || (expired ? '' : '<div style="color:var(--muted);font-size:14px">No points applied yet — open a product and tap \u201cApply Points\u201d.</div>')) +
        '<div style="margin-top:12px;padding-top:10px;border-top:2px solid var(--line)">' +
          '<div class="kid-tot"><span style="color:var(--muted)">Total points applied</span><span style="font-weight:600">' + fmtPts(summary.totalPoints) + ' pts</span></div>' +
          '<div class="kid-tot"><span style="color:var(--muted)">Total savings</span><span style="color:var(--mint-d);font-weight:800">' + fmtUsd(summary.totalCents) + '</span></div>' +
          '<div class="kid-tot"><span style="color:var(--muted)">Remaining balance</span><span style="font-weight:600">' + fmtPts(summary.availablePoints) + ' pts</span></div>' +
        '</div>' +
      '</div>';
  }

  // Inject/refresh the panel above each (non-express) checkout button. Shared by every state.
  // Bug 3 (flicker): cache the last-rendered HTML so the MutationObserver can re-inject it
  // INSTANTLY when Dawn wipes .drawer__inner on a /cart/change, instead of the panel vanishing
  // for the 200-400ms until the debounced cart-summary refresh completes.
  var _lastPanelHtml = '';
  function placePanel(html) {
    if (html) _lastPanelHtml = html;
    [].forEach.call(document.querySelectorAll(CHECKOUT_SEL), function (btn) {
      if (btn.closest(EXPRESS_SEL)) return;
      var surface = btn.closest(SURFACE_SEL) || btn.parentNode;
      if (!surface) return;
      var existing = surface.querySelector('.kid-cart-panel');
      if (existing) { existing.innerHTML = html; return; }
      var panel = document.createElement('div');
      panel.className = 'kid-wrap kid-cart-panel'; panel.innerHTML = html;
      if (btn.parentNode) btn.parentNode.insertBefore(panel, btn); // sit ABOVE Check out
    });
  }

  function renderPanels(summary, cart, info) { placePanel(panelHtml(summary, cart, info)); }

  // Logged-out / stale-token: show the generic login prompt, but ONLY if the cart has items.
  function renderLoggedOut() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.item_count) return;            // empty cart → render nothing
      _mutatingSelf = true;
      try { placePanel(loggedOutHtml()); } finally { setTimeout(function () { _mutatingSelf = false; }, 0); }
    }).catch(function () {});
  }

  function refreshCart() {
    if (!checkoutTrigger(document.querySelector(CHECKOUT_SEL))) return; // no cart surface visible
    if (!authed()) { renderLoggedOut(); return; }           // logged-out: generic login prompt (if items)
    loadCart().then(function (res) {
      // AUTO-SCALE (max-intent): lines where the member originally applied AT MAX (appliedAtMax,
      // ≥95% of cap — clear intent: "max points on this item") AND the cart quantity has since
      // increased (underApplied) get their points auto-scaled to the new quantity — no consent tap
      // needed, because scaling honors the intent they already expressed. Partial applies
      // (appliedAtMax:false) keep the consent prompt (underSection). Server-side enforcement is
      // unchanged: this still round-trips /api/allocate under the profile lock (cap + balance
      // re-validated, clamp-on-reject) — the flag changes consent UX, never enforcement, so
      // auto-scale can never overdraw; worst case it applies what balance allows.
      // Guards: _reapplying mutex (never race the manual buttons); _autoScaling (once per refresh
      // cycle — after success the refreshed summary shows underApplied:false so it naturally stops).
      var autoLines = [];
      if (!_reapplying && !_autoScaling && res.summary && !res.summary.unauthorized) {
        autoLines = ((res.summary.lines) || [])
          .filter(function (l) { return l.underApplied && l.appliedAtMax && l.additionalPoints > 0; })
          .map(function (l) { return { productId: l.productId, variantId: l.variantId, quantity: l.quantity, points: (l.points || 0) + l.additionalPoints, add: l.additionalPoints }; });
      }
      if (autoLines.length) {
        _autoScaling = true;
        var addedPts = 0;
        // Sequential allocates (same rationale as reapplyAll: no race on the profile lock).
        autoLines.reduce(function (chain, l) {
          return chain.then(function () {
            return fetch(APP + '/api/allocate', {
              method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }),
              body: JSON.stringify({ cartSessionId: res.token, productId: l.productId, variantId: l.variantId, points: l.points, quantity: l.quantity })
            }).then(function (r) { return r.json(); })
              .then(function (d) { if (d && d.success) addedPts += l.add; })
              .catch(function () {});                        // per-line failure: skip; prompt path still exists next refresh
          });
        }, Promise.resolve()).then(function () {
          // Re-render with FRESH post-scale data + a small acknowledgment (auto ≠ invisible).
          return loadCart().then(function (res2) {
            _mutatingSelf = true;
            try {
              if (res2.summary && res2.summary.unauthorized) { renderLoggedOut(); _unpointedCount = 0; _hasBalance = false; }
              else {
                var info2 = computeUnpointed(res2.summary, res2.cart);
                _unpointedCount = info2.count; _hasBalance = info2.hasBalance;
                renderPanels(res2.summary || {}, res2.cart || {}, info2);
                if (addedPts > 0) {
                  [].forEach.call(document.querySelectorAll('.kid-cart-panel .kid-panel'), function (p) {
                    var ex = p.querySelector('.kid-autoscale-note'); if (ex && ex.parentNode) ex.parentNode.removeChild(ex);
                    p.insertAdjacentHTML('afterbegin',
                      '<div class="kid-autoscale-note" style="margin:0 0 10px;padding:10px 12px;border-radius:12px;background:var(--cream);border:1px solid var(--line);font-size:13px;color:var(--forest)">' +
                      'Applied ' + fmtPts(addedPts) + ' more points to match your new quantity.' +
                      '</div>');
                  });
                }
              }
            } finally { setTimeout(function () { _mutatingSelf = false; }, 0); }
          });
        }).catch(function (err) { console.warn('[kidnomics] auto-scale failed', err); })
          .then(function () { _autoScaling = false; });
        return;   // the post-scale re-render above replaces this cycle's normal render
      }
      _mutatingSelf = true;
      try {
        if (res.summary && res.summary.unauthorized) { renderLoggedOut(); _unpointedCount = 0; _hasBalance = false; }   // stale/expired token
        else {
          // NUDGE — refresh cached snapshot (drives the banner + the checkout confirm). Defensive.
          var info = computeUnpointed(res.summary, res.cart);
          _unpointedCount = info.count; _hasBalance = info.hasBalance;
          renderPanels(res.summary || {}, res.cart || {}, info);
        }
      } finally { setTimeout(function () { _mutatingSelf = false; }, 0); }
    }).catch(function (err) { console.warn('[kidnomics] cart refresh failed', err); });
  }
  function scheduleRefresh() { if (_refreshTimer) return; _refreshTimer = setTimeout(function () { _refreshTimer = null; refreshCart(); }, 200); }

  function init() {
    // ONE capturing listener — survives drawer/cart re-renders, beats the theme's own handler.
    document.addEventListener('click', function (e) {
      if (!authed()) return;                 // logged-out: let stock checkout proceed untouched
      if (!checkoutTrigger(e.target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // NUDGE — soft gate: a member about to check out at full price while points are available
      // + items are un-pointed gets ONE confirm. Uses the cached snapshot (no extra fetch).
      // Fail-safe: only fires when we POSITIVELY know both; defaults (0 / false) skip it.
      // Cancel = stay (do NOT proceed); Confirm = settle as normal.
      if (_unpointedCount > 0 && _hasBalance) {
        if (!window.confirm('You have points available — check out at full price?')) return;
      }
      if (!_settling) settleAndGo();
    }, true);

    // Re-apply button — Deploy 2: actually re-allocate points (THIS SPENDS POINTS). Re-fetches
    // the cart at tap-time so the list is the LIVE-scoped expiredLines (removed items dropped,
    // qty re-capped by cart-summary) — never a render-time snapshot. Per line: POST /api/allocate;
    // on a stale-amount REJECT, clamp ONCE to the limit the server returns (cap or available) and
    // retry. The server re-validates cap + balance under a profile lock — it can reject but never
    // over-apply — so we trust its accept/reject and add NO client-side balance math. Separate
    // non-capturing listener; never touches the capturing checkout-interception listener.
    document.addEventListener('click', function (e) {
      // Handles BOTH .kid-reapply (expired lines) and .kid-applymore (Bug 2b: quantity-increased
      // under-applied lines). Same hardened allocate machinery — allocate each source line at its
      // CURRENT quantity for the full amount; the server caps to cap×qty under a profile lock,
      // re-validated, clamp-on-reject. The only difference is WHICH lines feed it (expiredLines vs
      // the underApplied active lines) — selected at tap-time from a fresh cart-summary.
      var btn = (e.target && e.target.closest) ? (e.target.closest('.kid-reapply') || e.target.closest('.kid-applymore')) : null;
      if (!btn) return;
      var isApplyMore = btn.classList.contains('kid-applymore');
      e.preventDefault();
      if (_reapplying) return;                          // double-tap guard (button is also disabled)
      _reapplying = true;
      btn.disabled = true; btn.textContent = isApplyMore ? 'Applying\u2026' : 'Re-applying\u2026';

      // One /api/allocate POST for a given points amount (matches the allocate route shape).
      function allocateOnce(token, l, pts) {
        return fetch(APP + '/api/allocate', {
          method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify({ cartSessionId: token, productId: l.productId, variantId: l.variantId, points: pts, quantity: l.quantity })
        }).then(function (r) { return r.json(); });
      }
      // The server-supplied limit to clamp to on a stale-amount reject (else null → hard-fail).
      function clampLimit(d) {
        if (!d) return null;
        if (d.error_code === 'EXCEEDS_VARIANT_CAP' && typeof d.cap === 'number') return Math.floor(d.cap);
        if (d.error_code === 'INSUFFICIENT_POINTS' && typeof d.available === 'number') return Math.floor(d.available);
        return null;
      }
      // Re-apply one line: try full amount; on a stale-amount reject, clamp ONCE and retry.
      function reapplyOne(token, l, results) {
        return allocateOnce(token, l, l.points).then(function (d) {
          if (d && d.success) { results.push({ status: 'full', points: l.points }); return; }
          var limit = clampLimit(d);
          if (limit == null || limit < 1) { results.push({ status: 'failed' }); return; } // available 0 / hard error
          return allocateOnce(token, l, limit).then(function (d2) {
            results.push(d2 && d2.success ? { status: 'clamped', points: limit } : { status: 'failed' });
          });
        }).catch(function () { results.push({ status: 'failed' }); });            // network / non-JSON
      }
      // Sequential (await each) so concurrent allocates can't race the profile-lock availability.
      function reapplyAll(token, lines) {
        var results = [];
        return lines.reduce(function (chain, l) {
          return chain.then(function () { return reapplyOne(token, l, results); });
        }, Promise.resolve()).then(function () {
          var applied = 0, shortfall = 0;
          results.forEach(function (r) {
            if (r.status === 'full' || r.status === 'clamped') applied += (r.points || 0);
            if (r.status === 'clamped' || r.status === 'failed') shortfall++;
          });
          return { appliedCents: applied, shortfall: shortfall };
        });
      }
      // Honest post-action notice (only when something fell short of the displayed amount).
      function noteHtml(o) {
        var n = o.shortfall;
        return '<div class="kid-reapply-note" style="margin:0 0 10px;padding:10px 12px;border-radius:12px;background:var(--cream);border:1px solid var(--line);font-size:13px;color:var(--forest)">' +
          'Re-applied ' + fmtUsd(o.appliedCents) + '. ' + n + ' item' + (n > 1 ? 's' : '') + ' couldn\u2019t get full points — you\u2019ve used your available balance. You can still buy ' + (n > 1 ? 'them' : 'it') + ' (and earn 3 pts per $1).' +
          '</div>';
      }
      function injectNote(o) {
        [].forEach.call(document.querySelectorAll('.kid-cart-panel .kid-panel'), function (p) {
          var ex = p.querySelector('.kid-reapply-note'); if (ex && ex.parentNode) ex.parentNode.removeChild(ex);
          p.insertAdjacentHTML('afterbegin', noteHtml(o));
        });
      }

      // Tap-time re-fetch → FRESH live-scoped lines. Never the render-time snapshot.
      loadCart().then(function (res) {
        if (res.summary && res.summary.unauthorized) { refreshCart(); return null; }  // session expired between render and tap
        var lines;
        if (isApplyMore) {
          // Bug 2b: under-applied (quantity-increased) active lines. Allocate each at its CURRENT
          // quantity for the FULL potential (points_now + additionalPoints) so the server caps it
          // to cap×qty. Build the target amount = current points + the additional headroom.
          lines = ((res.summary && res.summary.lines) || [])
            .filter(function (l) { return l.underApplied && !l.appliedAtMax && l.additionalPoints > 0; })
            .map(function (l) { return { productId: l.productId, variantId: l.variantId, quantity: l.quantity, points: (l.points || 0) + l.additionalPoints }; });
        } else {
          lines = (res.summary && res.summary.expiredLines) || [];
        }
        if (!lines.length) { refreshCart(); return null; }                            // nothing to (re)apply
        return reapplyAll(res.token, lines).then(function (outcome) {
          // Re-render with FRESH data (re-applied lines are now active → normal applied panel),
          // then prepend the shortfall notice in the SAME tick so refresh can't race it.
          return loadCart().then(function (res2) {
            _mutatingSelf = true;
            try {
              if (res2.summary && res2.summary.unauthorized) { refreshCart(); }
              else {
                var info2 = computeUnpointed(res2.summary, res2.cart);
                _unpointedCount = info2.count; _hasBalance = info2.hasBalance;
                renderPanels(res2.summary || {}, res2.cart || {}, info2);
                if (outcome.shortfall > 0) injectNote(outcome);
              }
            } finally { setTimeout(function () { _mutatingSelf = false; }, 0); }
          });
        });
      }).catch(function (err) {
        console.warn('[kidnomics] ' + (isApplyMore ? 'apply-more' : 're-apply') + ' failed', err);
        if (btn) { btn.disabled = false; btn.textContent = isApplyMore ? 'Apply more points' : 'Re-apply my points'; }    // re-enable so they can retry
        try { refreshCart(); } catch (e2) {}
      }).then(function () { _reapplying = false; });   // finally-equivalent: always clear the guard
    });

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        if (_mutatingSelf) return;            // ignore our own panel writes
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (!t || t.nodeType !== 1 || !t.closest) continue;
          if (t.closest('.kid-wrap')) continue;       // our own writes
          if (!t.closest(CART_CTX)) continue;         // ONLY cart-region mutations -> no loop-fetch from search/anim
          // Bug 3 (flicker): Dawn wipes .drawer__inner on /cart/change, destroying our panel; the
          // real refresh is ~200-400ms behind (debounce + cart-summary round trip). If the panel is
          // now MISSING and we have a cached render, re-inject it INSTANTLY so it doesn't visibly
          // vanish. The subsequent refresh overwrites it with fresh data. Guarded so this stopgap
          // never fires without a prior render.
          if (_lastPanelHtml && !document.querySelector('.kid-cart-panel')) {
            _mutatingSelf = true;
            try { placePanel(_lastPanelHtml); } finally { setTimeout(function () { _mutatingSelf = false; }, 0); }
          }
          scheduleRefresh(); return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Belt #1 (primary): refresh after any Shopify cart mutation request — render-agnostic,
    // catches qty +/-, remove, add on cart page AND drawer. Bulletproof + idempotent.
    if (!window.__kidFetchWrapped) {
      window.__kidFetchWrapped = true;
      var _kidFetch = window.fetch;
      window.fetch = function (input) {
        var p = _kidFetch.apply(this, arguments);
        try {
          var u = (typeof input === 'string') ? input : (input && input.url) || '';
          if (/\/cart\/(change|update|add|clear)(\.js)?($|\?)/.test(u)) {
            p.then(function (r) { try { if (r && r.ok) scheduleRefresh(); } catch (e) {} }, function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    refreshCart();                            // initial: cart page, or a drawer already open
  }

  // ============================================================================
  // NAV POINTS BOX — a small header widget: "Hi {name} · {pts} pts" linking to the
  // parent dashboard (kidnomics.com/dashboard). Consolidates sign-in awareness (shows
  // who's logged in), back-to-Kidnomics (the dashboard link), and a live points readout.
  // Sign-out is handled BY the dashboard (the link's destination) — no cross-domain
  // sign-out here. Fully self-contained: own DOM target (.kid-navbox), own fetch; never
  // touches the cart/checkout money path. JS-injected into .header__icons (before search)
  // because the Liquid header renders server-side with no knowledge of the parent session.
  // ============================================================================
  var _navBoxDone = false;
  function initNavBox() {
    if (_navBoxDone) return;                 // once only (guards the auth-ready + immediate double-call)
    var icons = document.querySelector('.header__icons');
    if (!icons) return;                      // no header cluster on this page → nothing to do
    _navBoxDone = true;

    // Scoped styles for the box (brand: DM Sans, nav blue #0a329f, mint #4CAF6F emphasis).
    if (!document.getElementById('kid-navbox-style')) {
      var st = document.createElement('style'); st.id = 'kid-navbox-style';
      st.textContent = [
        // Defeat the theme's fixed 44px clamp on .header__icons>a (component-list-menu.css) —
        // scoped to .kid-navbox only via higher specificity, so search/account/cart keep their
        // 44px icon boxes. Without this the box is squeezed to 44px + content-centered, hiding
        // the name off the left edge.
        '.header .header__icons > a.kid-navbox{width:auto;height:auto;justify-content:flex-start;flex:0 0 auto}',
        '.kid-navbox{display:inline-flex;align-items:center;gap:6px;margin-right:14px;padding:6px 12px;',
        'border:1px solid rgba(10,50,159,.25);border-radius:999px;text-decoration:none;',
        'font-family:"DM Sans",system-ui,sans-serif;font-size:13px;font-weight:600;color:#0a329f;',
        'line-height:1;white-space:nowrap;transition:background .15s ease}',
        '.kid-navbox:hover{background:rgba(10,50,159,.06)}',
        '.kid-navbox .kid-navbox-pts{color:#3C9A5C;font-weight:700}',
        '.kid-navbox .kid-navbox-name{max-width:120px;overflow:hidden;text-overflow:ellipsis}',
        '@media (max-width:749px){.kid-navbox{margin-right:8px;padding:5px 10px;font-size:12px}',
        '.kid-navbox .kid-navbox-name{display:none}}'   // mobile: points-only (drop the name to save width)
      ].join('');
      document.head.appendChild(st);
    }

    // Build (or reuse) the anchor, inserted BEFORE the search modal so the cluster reads
    // [box] search cart. Matches the header__icon link pattern.
    var box = icons.querySelector('.kid-navbox');
    if (!box) {
      box = document.createElement('a');
      box.className = 'kid-navbox header__icon link focus-inset';
      var searchNode = icons.querySelector('.header__search') || icons.firstChild;
      icons.insertBefore(box, searchNode);
    }

    function renderLoggedOut() {
      box.setAttribute('href', 'https://kidnomics.com/login');
      box.innerHTML = '<span class="kid-navbox-name">Log in</span>';
    }
    function renderLoading() {
      box.setAttribute('href', 'https://kidnomics.com/dashboard');
      box.innerHTML = '<span class="kid-navbox-pts">…</span>';
    }
    function renderMember(fullName, pts) {
      box.setAttribute('href', 'https://kidnomics.com/dashboard');
      var first = (fullName || '').trim().split(/\s+/)[0] || '';
      var nameHtml = first ? '<span class="kid-navbox-name">Hi ' + first.replace(/[<>&]/g, '') + '</span><span aria-hidden="true">\u00b7</span>' : '';
      box.innerHTML = nameHtml + '<span class="kid-navbox-pts">' + fmtPts(pts) + ' pts</span>';
    }

    if (!authed()) { renderLoggedOut(); return; }   // logged-out: "Log in" → parent login

    renderLoading();
    fetch(APP + '/api/my-points', { headers: authHeaders() })
      .then(function (r) {
        if (r.status === 401) { renderLoggedOut(); return null; }   // stale token → treat as logged-out
        if (!r.ok) return null;                                     // other error → leave the loading dash, non-blocking
        return r.json();
      })
      .then(function (d) {
        if (!d) return;
        var pts = (typeof d.availablePoints === 'number') ? d.availablePoints : 0;
        renderMember(d.fullName, pts);
      })
      .catch(function () { /* network error: leave the dash; the box is informational, never blocks */ });
  }
  // The auth bridge (inline, earlier in body) runs before this deferred asset, so kidnomicsUser
  // is usually ready — but keep the listener as race insurance (same pattern as the slider).
  if (window.kidnomicsUser !== undefined) initNavBox();
  else window.addEventListener('kidnomics:auth-ready', initNavBox);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();